// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "evolucao-c53ad.firebaseapp.com",
  "projectId": "evolucao-c53ad",
  "storageBucket": "evolucao-c53ad.appspot.com",
  "messagingSenderId": "1068385872005",
  "appId": "1:1068385872005:web:a45086ea3d3a3eef65e1ec",
  "measurementId": "G-QJMRBJW1M5",
  "apiKey": "AIzaSyDZj4iWySW-_qCSZC8gbBgMxslyeN3uAYM"
};
